import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row, Progress, Badge } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import YourBalanceCard from "../../Common/CommonWidgets/YourBalanceCard";
import { Link } from "react-router-dom";
import { AVATAR, JOBSEEKER_PROFILE_IMAGE } from "../../../Constant";
import { capitalize } from "../../Common/CommonFunction";
import { useNavigate } from "react-router-dom";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";

const PROFILE_SECTIONS_CONFIG = [
  {
    key: "resume_upload",
    label: "Resume",
    check: (data) =>
      data?.isResumeUploaded === false ||
      data?.is_uploaded_resume === false ||
      !data?.jobseeker_resume_file,
  },
  {
    key: "education",
    label: "Education",
    check: (data) => !Array.isArray(data?.education) || data.education.length === 0,
  },
  {
    key: "work_experience",
    label: "Work Experience",
    check: (data) =>
      !Array.isArray(data?.work_experience) || data.work_experience.length === 0,
  },
  {
    key: "key_skills",
    label: "Key Skills",
    check: (data) =>
      (!Array.isArray(data?.key_skills) || data.key_skills.length === 0) &&
      (!Array.isArray(data?.jobseeker_skills) || data.jobseeker_skills.length === 0) &&
      (!Array.isArray(data?.technical_skills) || data.technical_skills.length === 0),
  },
  {
    key: "job_preferences",
    label: "Career Profile",
    check: (data) => !data?.jobseeker_preferred_job_title && !data?.desire_career,
  },
  {
    key: "work_sample",
    label: "Work Sample",
    check: (data) =>
      !Array.isArray(data?.work_sample) || data.work_sample.length === 0,
  },
  {
    key: "resume_headline",
    label: "Resume Headline",
    check: (data) => !data?.jobseeker_resume_headline,
  },
  {
    key: "online_profiles",
    label: "Social Links",
    check: (data) =>
      !Array.isArray(data?.social_media) || data.social_media.length === 0,
  },
];

const GreetingCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const dashboardReducerdData = useSelector(
    (state) => state.jobseekerDashboardReducer
  );
  const fetchJobseekerDataState = useSelector(
    (state) => state.fetchJobseekerDataReducer
  );

  let countData = [];
  let profileCompletionPercentage;
  let visitorCount;
  let contactCount;

  if (
    !dashboardReducerdData.isLoading &&
    dashboardReducerdData.data &&
    dashboardReducerdData.data.data &&
    dashboardReducerdData.data.data.jobseeker_details
  ) {
    countData = dashboardReducerdData.data.data.jobseeker_details;
    profileCompletionPercentage =
      dashboardReducerdData.data.data.profile_completion_percentage;
    visitorCount = dashboardReducerdData.data.data.visitors_count;
    contactCount = dashboardReducerdData.data.data.contact_count;
  }

  const { jobseeker_full_name, jobseeker_location, jobseeker_photo } =
    countData;

  const [imageVersion, setImageVersion] = useState(Date.now());

  useEffect(() => {
    if (jobseeker_photo) {
      setImageVersion(Date.now());
    }
  }, [jobseeker_photo]);

  useEffect(() => {
    if (!fetchJobseekerDataState?.data && !fetchJobseekerDataState?.isLoading) {
      dispatch(fetchJobseekerDataRequest());
    }
  }, [dispatch, fetchJobseekerDataState]);

  const profileData =
    fetchJobseekerDataState?.data?.data || dashboardReducerdData?.data?.data;

  const getMissingSections = () => {
    if (!profileData) return [];
    const missing = [];
    const completionSections = profileData?.profile_completion_sections;

    PROFILE_SECTIONS_CONFIG.forEach((sec) => {
      if (completionSections && completionSections[sec.key] !== undefined) {
        if (!completionSections[sec.key]?.complete) {
          missing.push(sec);
        }
      } else if (sec.check(profileData)) {
        missing.push(sec);
      }
    });

    return missing;
  };

  const missingSections = getMissingSections();

  const handleEditClick = () => {
    navigate(`${process.env.PUBLIC_URL}/jobseeker/update_profile`);
  };

  return (
    <Card className="balance-box">
      <CardBody>
        <div className="balance-profile d-flex align-items-center">
          <div className="d-flex flex-column align-items-center me-3">
            <div className="balance-img mb-2">
              {jobseeker_photo ? (
                <img
                  src={`${jobseeker_photo}?t=${imageVersion}`}
                  alt="user vector"
                  width="64"
                  height="64"
                  className="rounded-circle"
                />
              ) : (
                <img
                  src={`${AVATAR}?t=${imageVersion}`}
                  alt="default user"
                  width="64"
                  height="64"
                  className="rounded-circle"
                />
              )}
            </div>
            <button
              className="btn btn-primary  "
              style={{ paddingTop: 2, paddingBottom: 2 }}
              onClick={handleEditClick}
            >
              Edit
            </button>
          </div>
          <div className="text-break flex-grow-1">
            <h5 className="mb-0 text-start ">{capitalize(jobseeker_full_name)}</h5>
            <div className="progress-showcase row mt-3 ">
              <div className="col-12 text-right mb-2">
                <Progress
                  value={profileCompletionPercentage}
                  color="info"
                  className="sm-progress-bar"
                />
              </div>

              <div className="col-12 d-flex justify-content-between">
                <div className="text-start" style={{ fontSize: 13 }}>
                  {profileCompletionPercentage}% profile completed
                </div>
                {profileCompletionPercentage != 100 && (
                  <Link
                    className="edit-icon text-end" style={{ fontSize: 13 }}
                    to={`${process.env.PUBLIC_URL}/jobseeker/update_profile`}
                  >
                    Complete Profile
                  </Link>
                )}
              </div>

              {missingSections.length > 0 && profileCompletionPercentage != 100 && (
                <div className="col-12 mt-2 d-flex flex-wrap align-items-center gap-1">
                  <span className="text-muted" style={{ fontSize: "11px", fontWeight: 500 }}>
                    To complete:
                  </span>
                  {missingSections.slice(0, 2).map((sec) => (
                    <Badge
                      key={sec.key}
                      color="warning"
                      pill
                      className="text-dark bg-warning-subtle border border-warning"
                      style={{
                        fontSize: "11px",
                        padding: "3px 8px",
                        cursor: "pointer",
                        fontWeight: 500,
                      }}
                      onClick={() => navigate(`${process.env.PUBLIC_URL}/jobseeker/update_profile`)}
                      title={`Click to add ${sec.label}`}
                    >
                      + {sec.label}
                    </Badge>
                  ))}
                </div>
              )}

            </div>
          </div>
        </div>

        <div className="radial-progress-card ">
          <Col
            xl="12"
            sm="6"
            className="d-flex justify-content-around align-items-center "
          >
          </Col>
        </div>
      </CardBody>
    </Card>
  );
};

export default GreetingCard;
